import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/Button.js';
import { Card, CardBody, CardHeader, CardTitle } from '../../components/ui/Card.js';
import { useActividadesList } from '../../lib/queries/actividades.js';

export function ActividadesList() {
  const [rama, setRama] = useState<string>('');
  const [tipo, setTipo] = useState<string>('');
  const [quarter, setQuarter] = useState<string>('');
  const filters: { rama?: string; tipo?: string; quarter?: string } = {};
  if (rama) filters.rama = rama;
  if (tipo) filters.tipo = tipo;
  if (quarter) filters.quarter = quarter;
  const { data, isLoading, error } = useActividadesList(filters);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold text-distrito-700">Actividades</h1>
        <Link to="/actividades/new">
          <Button variant="primary">+ Nueva actividad</Button>
        </Link>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Filtros</CardTitle>
        </CardHeader>
        <CardBody>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">Rama</span>
              <select
                className="px-3 py-2 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-distrito-500"
                value={rama}
                onChange={(e) => setRama(e.target.value)}
              >
                <option value="">Todas</option>
                <option value="manada">Manada</option>
                <option value="tropa">Tropa</option>
                <option value="caravana">Caravana</option>
                <option value="comunidad">Comunidad</option>
              </select>
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">Tipo</span>
              <select
                className="px-3 py-2 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-distrito-500"
                value={tipo}
                onChange={(e) => setTipo(e.target.value)}
              >
                <option value="">Todos</option>
                <option value="junta_semanal">Junta semanal</option>
                <option value="evento">Evento</option>
                <option value="servicio">Servicio</option>
                <option value="reclutamiento">Reclutamiento</option>
                <option value="capacitacion">Capacitación</option>
                <option value="evento_internacional">Evento internacional</option>
              </select>
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-sm font-medium text-gray-700">Quarter (YYYY-Qn)</span>
              <input
                className="px-3 py-2 border border-gray-300 rounded-md text-base focus:outline-none focus:ring-2 focus:ring-distrito-500"
                placeholder="2026-Q1"
                value={quarter}
                onChange={(e) => setQuarter(e.target.value)}
              />
            </label>
          </div>
        </CardBody>
      </Card>

      {isLoading && <div className="text-center py-8 text-gray-600">Cargando…</div>}
      {error && (
        <div className="p-4 bg-red-50 border border-red-200 rounded-md text-red-700" role="alert">
          Error: {error.message}
        </div>
      )}

      {data && (
        <Card>
          <CardBody>
            {data.data.data.length === 0 ? (
              <p className="text-center py-8 text-gray-500">
                Sin resultados para los filtros aplicados.
              </p>
            ) : (
              <table className="w-full text-sm">
                <thead className="bg-distrito-50 border-b border-distrito-100">
                  <tr className="text-left">
                    <th className="px-4 py-3 font-bold text-xs uppercase tracking-wider text-distrito-700">
                      Fecha
                    </th>
                    <th className="px-4 py-3 font-bold text-xs uppercase tracking-wider text-distrito-700">
                      Nombre
                    </th>
                    <th className="px-4 py-3 font-bold text-xs uppercase tracking-wider text-distrito-700">
                      Tipo
                    </th>
                    <th className="px-4 py-3 font-bold text-xs uppercase tracking-wider text-distrito-700">
                      Rama
                    </th>
                    <th className="px-4 py-3 font-bold text-xs uppercase tracking-wider text-distrito-700">
                      Quarter
                    </th>
                    <th className="px-4 py-3" />
                  </tr>
                </thead>
                <tbody>
                  {data.data.data.map((a) => (
                    <tr
                      key={a.entity_id}
                      className="border-b border-gray-100 hover:bg-distrito-50/60 transition-colors"
                    >
                      <td className="px-4 py-3 text-xs">{a.fecha_actividad}</td>
                      <td className="px-4 py-3">{a.nombre}</td>
                      <td className="px-4 py-3">{a.tipo}</td>
                      <td className="px-4 py-3">{a.rama}</td>
                      <td className="px-4 py-3 font-mono text-xs">{a.quarter}</td>
                      <td className="px-4 py-3 text-right">
                        <Link
                          to={`/actividades/${a.entity_id}`}
                          className="text-distrito-600 hover:text-distrito-800 font-semibold"
                        >
                          Ver →
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {data.data.has_more && (
              <p className="text-sm text-gray-500 mt-3">
                Hay más resultados. Paginación V2 wired pronto.
              </p>
            )}
          </CardBody>
        </Card>
      )}
    </div>
  );
}
